import { Component, Input, OnInit } from '@angular/core';

import { CommonViewDto } from '../../models/common-view-dto';
import { DateFormatService } from '../../services/dateFormatter';
import { CONSTANTS } from '../../models/constants';
import { BusinessType } from 'src/app/api/invoice/models';
import { ActivatedRoute } from '@angular/router';
import { CurrencyConversionService } from '../../services/currencyConversion';

@Component({
  selector: 'app-common-view',
  templateUrl: './common-view.component.html',
  styleUrls: ['./common-view.component.scss'],
})
export class CommonViewComponent implements OnInit {
  @Input() viewTitle = '';
  @Input() ViewDetails!: CommonViewDto;
  @Input() loader?: boolean;
  @Input() useSalesFlightLabels = false;
  @Input() hideTripNumber = false;
  constants = CONSTANTS;
  showFirstAidColumns = false;
  isFinanceQuotation = false;

  BusinessType = BusinessType;
  constructor(
    public dateFormatService: DateFormatService,
    private route: ActivatedRoute,
    public currencyConversionService: CurrencyConversionService
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const firstSegment = this.route.snapshot.url[0].path;

      switch (firstSegment) {
        case 'first-aid-quotation':
          this.showFirstAidColumns = true;
          break;
        case 'finance-quotation':
          this.isFinanceQuotation = true;
          this.showFirstAidColumns = false;
          break;
        default:
          this.showFirstAidColumns = false;
          this.isFinanceQuotation = false;
      }
    });
    this.getTotalTaxableAmount();
  }
  getTotalTaxableAmount(): number {
    const totalExcludingVat = this.ViewDetails?.totalExcludingVat ?? 0;
    const totalOutOfScope = this.ViewDetails?.totalOutOfScope ?? 0;
    return totalExcludingVat - totalOutOfScope;
  }

  isQuotationTypeValid(): boolean {
    return !!(
      this.ViewDetails?.quotationNumber &&
      this.ViewDetails?.quotationType !== BusinessType.Mcc &&
      this.ViewDetails?.quotationType !== BusinessType.Training
    );
  }

  calculateTotal(unitPrice: number, quantity: number, vatAmount: number) {
    // Calculate the total using the formula: total = unitPrice * quantity + vatAmount
    const total = unitPrice * quantity + vatAmount;

    return total;
  }

  isEscortItem(type: string) {
    if (type === BusinessType.Escort) {
      return true;
    }
    return false;
  }

  hasAnyFlightNumber(): boolean {
    return !!this.ViewDetails?.legs?.some(
      (flight: { flightNumber?: string }) => !!flight?.flightNumber
    );
  }
}
